import { render, staticRenderFns } from "./SalesByRegion.vue?vue&type=template&id=a193d11e&scoped=true"
import script from "./SalesByRegion.vue?vue&type=script&lang=js"
export * from "./SalesByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a193d11e",
  null
  
)

export default component.exports